/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
var e={indexName:`DEV_fitments`,primaryIndexId:`facetFilter`,uniqueProductIndexId:`uniqueProductFilter`,fallbackIndexId:`nullFacetFilter`,hitsPerPage:24},t=[`BegYear`,`MakeName`,`ModelName`,`SubmodelName`];export{e as indexConfig,t as vehicleFacets};